export enum ComponentState {
    Rendered = 'rendered',
    Hydrated = 'hydrated',
}

export const DefaultAttributeType = String;
export const DefaultAttributeReflect = true;
